
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.72 6.41004C15.37 6.76004 15.28 7.29004 15.47 7.76004C15.77 8.51004 15.79 9.34004 15.52 10.1C15.36 10.56 15.46 11.08 15.81 11.42C16.41 12.02 17.47 11.89 17.83 11.11C18.47 9.72004 18.43 8.12004 17.71 6.70004C17.31 5.95004 16.3 5.82004 15.72 6.41004ZM19.18 2.89004C18.78 3.29004 18.72 3.91004 19.05 4.37004C20.98 7.05004 21 10.62 19.14 13.44C18.83 13.9 18.91 14.52 19.3 14.91C19.81 15.42 20.68 15.37 21.11 14.78C23.68 11.27 23.63 6.58004 20.94 3.01004C20.51 2.45004 19.68 2.39004 19.18 2.89004ZM9.43 5.04004L12.96 8.57004C12.76 6.71004 11.29 5.24004 9.43 5.04004ZM3.71 3.56004C3.32 3.95004 3.32 4.58004 3.71 4.97004L5.62 6.88004C5.06 7.77004 4.83 8.89004 5.15 10.08C5.51 11.41 6.59 12.48 7.92 12.85C9.11 13.18 10.23 12.94 11.12 12.38L15.52 16.78C13.74 15.6 10.78 15 9 15C6.33 15 1 16.34 1 19V20C1 20.55 1.45 21 2 21H16C16.55 21 17 20.55 17 20V19C17 18.63 16.89 18.3 16.71 17.98L19.02 20.29C19.41 20.68 20.04 20.68 20.43 20.29C20.82 19.9 20.82 19.27 20.43 18.88L5.12 3.56004C4.73 3.17004 4.1 3.17004 3.71 3.56004Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-voice-over-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconVoiceOverOff

    ```js
    <b-new-b-icon-voice-over-off />
    ```
</docs>


